/*
 * @Author: zhaoyi
 * @Date: 2017-09-11 11:11:01
 * @Last Modified by: ice
 * @Last Modified time: 2018-06-19 16:42:13
 */
import * as mtypes from '../types/mutation-types';

const state = {
    userInfo: {
        'user_type': 0,// 用户类型:1常规, 2游客, 3广告主, 0未登录
        'nick_name': '',
        'manager_no': '',
        'is_admin': 0,
        'header': 'http://cdn.wxhand.com/amb/images/header.png'
    }
};

const mutations = {
    [mtypes.SET_USER_INFO](state, userInfo) {
        state.userInfo.user_type = userInfo.user_type;
        state.userInfo.is_admin = userInfo.is_admin;
        state.userInfo.nick_name = userInfo.nick_name;
        state.userInfo.header = userInfo.user_head ? userInfo.user_head : 'http://cdn.wxhand.com/amb/images/header.png';
        state.userInfo.manager_no = userInfo.manager_no;
    },
    [mtypes.SET_LOG_OUT](state) {
        state.userInfo.user_type = 0;
        state.userInfo.nick_name = '';
        state.userInfo.is_admin = 0;
    }
};

export default {
    state,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/user-info.js